import React from 'react';

import {
  LanguageOption,
  SUPPORTED_LANGUAGES,
} from '@/inpatient-patient-pwa/i18n/constants';

export interface LanguageContext {
  /**
   * Languages the user may pick from — the intersection of what the app ships
   * and what the hospital enabled. Never wider than the hospital's set, and
   * empty when the hospital enabled none.
   */
  options: ReadonlyArray<LanguageOption>;
  /**
   * Whether the hospital's config has been read yet. False only until the login
   * query answers on a device that has never reached this hospital.
   */
  isResolved: boolean;
  /**
   * Registers the tags returned by `pwaLoginHospitalInfo`. Called from the login
   * screen, the only place that can read them from the API.
   */
  setSupportedLanguages: (languages?: ReadonlyArray<string> | null) => void;
}

/**
 * The default value only serves components rendered outside the app shell
 * (Storybook, unit tests) — `LanguageProvider` wraps the whole app and is the
 * authority everywhere else.
 */
const languageContext = React.createContext<LanguageContext>({
  options: SUPPORTED_LANGUAGES,
  isResolved: true,
  setSupportedLanguages: () => undefined,
});

export default languageContext;
